import { ServicePageTemplate } from "@/components/ServicePageTemplate";
import { ASSETS } from "@/lib/assets";
import { SEO } from "@/components/SEO";

const ALL_LINKS = [
  { label: "Rottebekæmpelse", to: "/ydelser/rottebekaempelse" },
  { label: "Kloakopgaver", to: "/ydelser/kloakopgaver" },
  { label: "Serviceaftale", to: "/ydelser/serviceaftale" },
  { label: "No-dig", to: "/ydelser/no-dig" },
];

export const Spul = () => (
  <>
    <SEO
      title="Spul & Rens – Højtryksspuling og TV-inspektion"
      description="Højtryksspuling og rens af afløb, faldstammer og kloak. Vi fjerner tilstopningen, TV-inspicerer ved behov og giver klar dokumentation af det udførte arbejde."
    />
    <ServicePageTemplate
    eyebrow="Spul & Rens"
    title={<>Fri passage i <em className="text-[color:var(--fk-gold)]">afløb og kloak.</em></>}
    subtitle="Vi udfører højtryksspuling, rensning og TV-inspektion, når afløb stopper til eller kloakken skal gennemgås. Vi fjerner tilstopningen, finder årsagen og dokumenterer arbejdet, når der er behov for det."
    heroImage={ASSETS.images.flush}
    intro="Afløb stopper sjældent uden grund. Vi renser, spuler og kontrollerer, så der igen er fri passage, og du får klar besked om, hvad vi har fundet."
    bullets={[
      "Højtryksspuling af afløb, faldstammer og kloak",
      "TV-inspektion ved behov for fejlfinding og dokumentation",
      "Dokumentation til forsikring, udlejer eller ejer",
      "Anbefalinger til forebyggelse af nye tilstopninger",
    ]}
    process={[
      { title: "Akutopkald", body: "Vi afklarer problemet og rykker hurtigt ud, når afløb eller kloak er stoppet til." },
      { title: "Spuling", body: "Vi renser systemet med højtryksspuling og det rette udstyr til opgaven." },
      { title: "Inspektion", body: "Vi TV-inspicerer ved behov og dokumenterer rørets tilstand, så årsagen bliver tydelig." },
      { title: "Anbefaling", body: "Du får klar besked om, hvad vi har fundet, og om der er behov for yderligere arbejde." },
    ]}
    ctaHeading="Er afløbet stoppet til?"
    ctaBody="Ring til døgnvagten, hvis afløb, toilet eller kloak er stoppet. Vi rykker ud, renser systemet og undersøger årsagen, så problemet ikke bare vender tilbage."
    related={ALL_LINKS}
  />
  </>
);
